// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "GifPlayer-module--bx--text-truncate--end--XyuJJ";
export var bxTextTruncateFront = "GifPlayer-module--bx--text-truncate--front--VXMZB";
export var container = "GifPlayer-module--container--NSCr+";
export var controls = "GifPlayer-module--controls--KrEbS";
export var dark = "GifPlayer-module--dark--jC8Cg";
export var gifDisplayed = "GifPlayer-module--gif-displayed---TMZd";
export var gifHidden = "GifPlayer-module--gif-hidden--ReE82";
export var gifInDialog = "GifPlayer-module--gif-in-dialog--PmK3a";
export var imgDisplayed = "GifPlayer-module--img-displayed--FpUsW";
export var imgHidden = "GifPlayer-module--img-hidden--0oAfp";